(function () {
  function createZoom(section) {
    var existing = document.querySelector('[data-raev-zoom-modal]');
    if (existing) return existing;

    var closeLabel = section.dataset.zoomCloseLabel || 'Cerrar imagen ampliada';
    var zoomAlt = section.dataset.zoomAlt || 'Imagen ampliada del producto';
    var modal = document.createElement('div');

    modal.className = 'raev-drop-zoom';
    modal.setAttribute('data-raev-zoom-modal', '');
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.innerHTML =
      '<button type="button" class="raev-drop-zoom__close" data-raev-zoom-close aria-label="' +
      closeLabel.replace(/"/g, '&quot;') +
      '">×</button><img class="raev-drop-zoom__image" data-raev-zoom-image alt="' +
      zoomAlt.replace(/"/g, '&quot;') +
      '">';

    document.body.appendChild(modal);

    modal.addEventListener('click', function (event) {
      if (event.target === modal || event.target.hasAttribute('data-raev-zoom-close')) {
        modal.classList.remove('is-open');
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') modal.classList.remove('is-open');
    });

    return modal;
  }

  function setLimitedUnits(root) {
    (root || document).querySelectorAll('[data-raev-drop-section] .raev-drop-specs').forEach(function (specs) {
      var values = specs.querySelectorAll('.raev-spec-value');
      if (values.length >= 3) values[2].textContent = '50 UND.';
    });
  }

  function initGallery(root) {
    root = root || document;
    setLimitedUnits(root);

    root.querySelectorAll('[data-raev-gallery]').forEach(function (gallery) {
      if (gallery.dataset.ready === 'true') return;
      gallery.dataset.ready = 'true';

      var section = gallery.closest('[data-raev-drop-section]');
      var slides = Array.prototype.slice.call(gallery.querySelectorAll('[data-raev-slide]'));
      var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-raev-thumb]'));
      var prev = gallery.querySelector('[data-raev-prev]');
      var next = gallery.querySelector('[data-raev-next]');
      var current = 0;

      function show(index) {
        if (!slides.length) return;
        current = (index + slides.length) % slides.length;

        slides.forEach(function (slide, slideIndex) {
          var active = slideIndex === current;
          slide.hidden = !active;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        });

        thumbs.forEach(function (thumb, thumbIndex) {
          thumb.classList.toggle('is-active', thumbIndex === current);
        });
      }

      if (prev) {
        prev.addEventListener('click', function () {
          show(current - 1);
        });
      }

      if (next) {
        next.addEventListener('click', function () {
          show(current + 1);
        });
      }

      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          show(Number(thumb.dataset.index || 0));
        });
      });

      slides.forEach(function (slide) {
        slide.addEventListener('click', function () {
          var modal = createZoom(section || document.documentElement);
          var image = modal.querySelector('[data-raev-zoom-image]');
          image.src = slide.dataset.zoomSrc;
          modal.classList.add('is-open');
        });
      });

      show(0);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initGallery(document);
    });
  } else {
    initGallery(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initGallery(event.target);
  });
})();

(function () {
  var mobileQuery = window.matchMedia('(max-width: 749px)');

  function safelyPlay(video) {
    var playPromise = video.play();

    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch(function () {});
    }
  }

  function observeHeroVideo() {
    var hero = document.getElementById('Hero-raev-hero');

    if (!hero || hero.dataset.raevMobileVideoReady === 'true') return;

    var videos = Array.prototype.slice.call(hero.querySelectorAll('video'));

    if (!videos.length) return;

    hero.dataset.raevMobileVideoReady = 'true';

    var observer = new IntersectionObserver(
      function (entries) {
        var isVisible = Boolean(entries[0] && entries[0].isIntersecting);

        videos.forEach(function (video) {
          if (isVisible) {
            safelyPlay(video);
          } else {
            video.pause();
          }
        });
      },
      {
        rootMargin: '100px 0px',
        threshold: 0.01,
      }
    );

    observer.observe(hero);
  }

  function observeMarquees(root) {
    root.querySelectorAll('marquee-component').forEach(function (marquee) {
      if (marquee.dataset.raevMobileMotionReady === 'true') return;

      var wrapper = marquee.querySelector('.marquee__wrapper');

      if (!wrapper) return;

      marquee.dataset.raevMobileMotionReady = 'true';
      wrapper.style.animationPlayState = 'paused';

      var observer = new IntersectionObserver(
        function (entries) {
          wrapper.style.animationPlayState =
            entries[0] && entries[0].isIntersecting ? 'running' : 'paused';
        },
        {
          rootMargin: '120px 0px',
          threshold: 0.01,
        }
      );

      observer.observe(marquee);
    });
  }

  function initMobilePerformance(root) {
    if (!mobileQuery.matches || !('IntersectionObserver' in window)) return;

    observeHeroVideo();
    observeMarquees(root || document);
  }

  function boot() {
    initMobilePerformance(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initMobilePerformance(event.target);
  });
})();
